import EADialog from "components/common/EADialog";
import ClassificationEsgScore from "./ClassificationEsgScore";
import i18next from "i18next";
import useStyles from "./EsgScoreModalStyle";
import EAIcon from "components/common/EAIcon";
import { convert } from "html-to-text";

const GlobalEsgScoreModal = ({dataESG, esgDetailsContent, isOpen, onClose}) => {
    const {classes} = useStyles();

    const peerPercentile = dataESG?.esgRanking?.peerPercentileGroup;

    if(!esgDetailsContent) {
        return <></>
    }

    return (
        <EADialog isOpen={isOpen && esgDetailsContent} onClose={onClose} title={i18next.t("ESG.scoreGlobalLabel")} maxWidth="lg" hasActions={false}>
            <div className={classes.gridColumns}>

                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["classification_title"]}</div>
                    <ClassificationEsgScore esgDetailsContent={esgDetailsContent} score={dataESG?.score} />
                </div>
                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["depth_scores_title"]}</div>
                    <div className={classes.flex}>
                        <div className={classes.score_bold}>{esgDetailsContent["esg_data_depth"]}</div>
                        <div className={classes.depthDescription}>{convert(esgDetailsContent["esg_data_depth_description"])}</div>
                    </div>

                </div>
                <div>
                    <div className={classes.subTitle}>{esgDetailsContent["peer_percentile_title"]}</div>
                    <div className={classes.flex}>
                        <div>{esgDetailsContent["esg_peer_percentile"]}</div>
                        {peerPercentile === "1 to 10" && <EAIcon icon="esg/peer-percentile_1_to_10" />}
                        {peerPercentile === "11 to 30" && <EAIcon icon="esg/peer-percentile_11_to_30" />}
                        {peerPercentile === "31 to 50" && <EAIcon icon="esg/peer-percentile_31_to_50" />}
                        {peerPercentile === "51 to 70" && <EAIcon icon="esg/peer-percentile_51_to_70" />}
                        {peerPercentile === "71 to 90" && <EAIcon icon="esg/peer-percentile_71_to_90" />}
                        {peerPercentile === "91 to 100" && <EAIcon icon="esg/peer-percentile_91_to_100" />}
                    </div>
                </div>
            </div>
            <div className={classes.globalDescription}>
                <p>{esgDetailsContent["overall_score_explanation_1"]}</p>
                <p>{esgDetailsContent["overall_score_explanation_2"]}</p>
            </div>
            
        </EADialog>
    )

}
export default GlobalEsgScoreModal;